import type { FC } from 'react';
import { ARROW_HEAD_SIZE, MARKER_ORIENT_AUTO, MARKER_UNITS_USERSPACE, sequenceColors, } from './sequence-constants';
import { SEQUENCE_ARROW_FILLED_ID, SEQUENCE_ARROW_OPEN_ID, } from './SequenceMessage';
const MARKER_OPEN_FILL = 'none';
const MARKER_OPEN_STROKE_WIDTH = 1.5;
export const SequenceArrowMarkers: FC = () => {
    return (
      <defs>
        <marker id={SEQUENCE_ARROW_FILLED_ID} markerWidth={ARROW_HEAD_SIZE} markerHeight={ARROW_HEAD_SIZE} refX={ARROW_HEAD_SIZE - 1} refY={ARROW_HEAD_SIZE / 2} orient={MARKER_ORIENT_AUTO} markerUnits={MARKER_UNITS_USERSPACE}>
          <path d={`M0,0 L${ARROW_HEAD_SIZE},${ARROW_HEAD_SIZE / 2} L0,${ARROW_HEAD_SIZE} z`} fill={sequenceColors.messageLine}/>
        </marker>
        <marker id={SEQUENCE_ARROW_OPEN_ID} markerWidth={ARROW_HEAD_SIZE} markerHeight={ARROW_HEAD_SIZE} refX={ARROW_HEAD_SIZE - 1} refY={ARROW_HEAD_SIZE / 2} orient={MARKER_ORIENT_AUTO} markerUnits={MARKER_UNITS_USERSPACE}>
          <path d={`M0,0 L${ARROW_HEAD_SIZE},${ARROW_HEAD_SIZE / 2} L0,${ARROW_HEAD_SIZE}`} fill={MARKER_OPEN_FILL} stroke={sequenceColors.messageLine} strokeWidth={MARKER_OPEN_STROKE_WIDTH}/>
        </marker>
      </defs>
    );
};
